


























































import Vue from "vue";
import { UserInfo } from "../../interfaces";
import {
  confirmDonation,
  getDonations,
  getProfile,
  OnlineDonation,
} from "../../services";

export default Vue.extend({
  components: {},
  data: () => ({
    donations: [] as ReadonlyArray<OnlineDonation>,
    dialogDetail: false,
    selectedItem: undefined as OnlineDonation | undefined,
    userInfo: {} as UserInfo | undefined,
    repititionMap: {
      1: 'Einmalig',
      2: 'Monatlich',
      3: 'Vierteljährlich',
      4: 'Jährlich'
    }
  }),
  async created() {
    this.userInfo = await getProfile();
    await this.getDonations();
  },
  methods: {
    askForConfirmation(selectedItem: OnlineDonation) {
      this.selectedItem = selectedItem;
      this.dialogDetail = true;
    },
    closeDialog() {
      this.dialogDetail = false;
      this.selectedItem = undefined;
    },
    async confirmItem() {
      if (!this.selectedItem) {
        return;
      }
      const id = this.selectedItem.id
      await confirmDonation(id);
      this.donations = this.donations.filter(d => d.id !== id);
      this.dialogDetail = false;
      this.selectedItem = undefined;

    },
    async getDonations() {
      this.donations = await getDonations();
    },
  },
});
